import React, { useCallback, useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Grid,
  Container,
  useTheme,
} from "@mui/material";
import { LanguageAutocomplete } from "../../widgets/LanguageAutocomplete";
import PageTitle from "../../widgets/PageTitle";

// Import slick carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TextFieldVariable from "../TextFieldVariable";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import WabaCarouselCreator from "./WabaCarouselTemplate";

// Main component
const WhatsAppCarouselCreator = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState({
    templateName: "",
    language: "en",
    messageBody: "",
    cards: [],
  });
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);

  const handleInputChange = (field, value) => {
    setTemplateData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreate = useCallback(async () => {
    if (templateData.cardsCount <= 0) {
      setError("Cards count must be greater than 0");
      return;
    }
    if (!templateData.templateName) {
      toast.error("Template name is required!");
      return;
    }
    setError("");

    try {
      setCreating(true);
      const response = await axios.post(
        `${API_ENDPOINT}/api/create-carousel`,
        templateData,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        navigate(`/home/templates`);
      }, 2000);
    } catch (error) {
      toastError(error);
    } finally {
      setCreating(false);
    }
  }, [templateData]);

  const handleUpdatedCards = useCallback((newV) => {
    setTemplateData((prev) => ({ ...prev, cards: newV }));
  }, []);
  return (
    <Container sx={{ mt: 3 }}>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <PageTitle mb={2}>Create Carousel Template</PageTitle>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Template Name"
              value={templateData.templateName}
              onChange={(e) => {
                let t = e.target.value.slice(0, 512);
                t = t.toLowerCase().replace(/[^a-z0-9_-]/g, "");
                handleInputChange("templateName", t);
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <LanguageAutocomplete
              value={templateData.language}
              onChange={(newV) => {
                console.log(newV);
                handleInputChange("language", newV);
              }}
            />
          </Grid>
        </Grid>
        <Box my={2}>
          <TextFieldVariable
            variableRequired={false}
            label="Message Body"
            onParamChange={(newV) => {}}
            value={templateData.messageBody}
            onChange={(newV) => handleInputChange("messageBody", newV)}
            multiline
            rows={3}
          />
        </Box>

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}

        <WabaCarouselCreator onUpdatedCards={handleUpdatedCards} />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <LoadingButton
            variant="contained"
            size="large"
            loading={creating}
            onClick={handleCreate}
          >
            Create Template
          </LoadingButton>
        </Box>
      </Paper>
    </Container>
  );
};

export default WhatsAppCarouselCreator;
